import {Component} from '@angular/core';

import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-skendata-registration',
    templateUrl: './skendata-registration-dialog.component.html',
    styleUrls: ['./skendata-registration-dialog.component.scss'],
    standalone: false
})
export class SkendataRegistrationDialogComponent {

  constructor(public dialogRef: MatDialogRef<SkendataRegistrationDialogComponent>) {}

}
